import { render, staticRenderFns } from "./footerMob.vue?vue&type=template&id=6b339f3b&scoped=true&"
import script from "./footerMob.vue?vue&type=script&lang=js&"
export * from "./footerMob.vue?vue&type=script&lang=js&"
import style0 from "./footerMob.vue?vue&type=style&index=0&id=6b339f3b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b339f3b",
  null
  
)

export default component.exports